import React, { useState, useRef, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { FaEye, FaPlus, FaEllipsisV } from 'react-icons/fa';
import "../css/productActionDropdown.sass";

const ProductActionDropdown = ({ onView, onCreate, productId }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [position, setPosition] = useState({ top: 0, left: 0 });
  const dropdownRef = useRef(null);
  const buttonRef = useRef(null);

  const handleToggle = () => {
    if (!isOpen && buttonRef.current) {
      const rect = buttonRef.current.getBoundingClientRect();
      setPosition({
        top: rect.bottom + window.scrollY + 5,
        left: rect.left + window.scrollX
      });
    }
    setIsOpen(!isOpen);
  };

  const handleView = () => {
    onView(productId);
    setIsOpen(false);
  };

  const handleCreate = () => {
    onCreate();
    setIsOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target) && 
          buttonRef.current && !buttonRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  const dropdownContent = (
    <div 
      ref={dropdownRef}
      className="dropdown-menu-portal"
      style={{
        position: 'absolute',
        top: `${position.top}px`,
        left: `${position.left}px`,
        zIndex: 999999
      }}
    >
      <button className="dropdown-item" onClick={handleView}>
        <FaEye />
        <span>View processes</span>
      </button>
      <button className="dropdown-item" onClick={handleCreate}>
        <FaPlus />
        <span>Create processes</span>
      </button>
    </div>
  );

  return (
    <div className="product-action-dropdown">
      <button 
        ref={buttonRef}
        className="dropdown-toggle" 
        onClick={handleToggle}
        aria-label="More actions"
      >
        <FaEllipsisV />
      </button>
      
      {isOpen && createPortal(dropdownContent, document.body)}
    </div>
  );
};

export default ProductActionDropdown;
